import React from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import { Newspaper, ArrowRight, ShieldAlert } from "lucide-react";

export default function AINews() {
  const navigate = useNavigate();

  return (
    <div className="flex h-screen bg-slate-50 text-slate-900 overflow-hidden">
      <Sidebar />

      <main className="flex-1 overflow-auto">
        <div className="mx-auto max-w-6xl px-8 py-10">
          <div className="flex flex-wrap items-start justify-between gap-4">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-700">
                <Newspaper size={14} />
                AI News Monitor
              </div>
              <h1 className="mt-3 text-3xl font-bold tracking-tight">AI News</h1>
              <p className="mt-1 text-sm text-slate-600">
                Curated regulatory and enforcement signals. (Placeholder page — wiring next.)
              </p>
            </div>

            <div className="flex gap-2">
              <button
                onClick={() => navigate("/dashboard")}
                className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold hover:bg-slate-50"
              >
                Back to Dashboard <ArrowRight size={16} />
              </button>

              <button
                onClick={() => navigate("/reports")}
                className="inline-flex items-center gap-2 rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold hover:bg-slate-50"
              >
                View Reports <ShieldAlert size={16} />
              </button>
            </div>
          </div>

          <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-8 shadow-sm">
            <h2 className="text-lg font-semibold">Status</h2>
            <p className="mt-2 text-sm text-slate-700">
              This module will display:
            </p>

            <ul className="mt-4 list-disc pl-6 text-sm text-slate-700 space-y-2">
              <li>Recent AI enforcement actions and regulatory updates</li>
              <li>Jurisdiction-specific alerts (US/UK/EU)</li>
              <li>Links to primary sources and key compliance takeaways</li>
              <li>Optional: evidence pack suggestions for remediation</li>
            </ul>

            <div className="mt-6 rounded-xl border border-blue-100 bg-blue-50 p-4 text-sm text-blue-900">
              Next implementation step: decide whether AI News is powered by your backend “Sifter”
              router (FastAPI) or a frontend-only feed.
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
